import React, { Component } from 'react'

import IconFacebook from '../icon/IconFacebook'
import IconInstagram from '../icon/IconInstagram'
import IconLabeled from '../iconLabeled/iconLabeled'
import IconMail from '../icon/IconMail'
import IconWhatsapp from '../icon/IconWhatsapp'
import Img from 'gatsby-image'
import PersonalCard from '../personalCard/personalCard'
import { Title3 } from '../title/title'
import styles from './contact.module.css'

const CONTACT_TITLE = 'Contacta'
const CONTACT_NAME = 'Jose Ignacio López de Ancos'
const CONTACT_POSITION = 'Sumiller / Wset2'
const CONTACT_INSTAGRAM = '@quantumvinos'
const CONTACT_FACEBOOK = 'quantumvinos'
const LINK_FACEBOOK = 'https://www.facebook.com/quantumvinos/'
const LINK_INSTAGRAM = 'https://www.instagram.com/quantumvinos/'
export const CONTACT_MAIL = 'quantunvinos@gmail.com'
export const CONTACT_WHATSAPP = '603737278'

export default class Contacconst extends Component {
  render() {
    return (
      <section className={styles.section}>
        <div className={styles.title}>
          <Title3 label={CONTACT_TITLE} />
        </div>
        <div className={styles.author}>
          <PersonalCard name={CONTACT_NAME} position={CONTACT_POSITION}>
            <Img
              title="author image"
              fixed={this.props.image}
              alt="author image"
            />
          </PersonalCard>
        </div>
        <ul className={styles.contacts}>
          <li className={styles.contact}>
            <IconLabeled label={CONTACT_INSTAGRAM} link={LINK_INSTAGRAM}>
              <IconInstagram color={'white'} />
            </IconLabeled>
          </li>
          <li className={styles.contact}>
            <IconLabeled label={CONTACT_FACEBOOK} link={LINK_FACEBOOK}>
              <IconFacebook color={'white'} />
            </IconLabeled>
          </li>
          <li className={styles.contact}>
            <IconLabeled label={CONTACT_MAIL} link={`mailto:${CONTACT_MAIL}`}>
              <IconMail color={'white'} />
            </IconLabeled>
          </li>
          <li>
            <IconLabeled label={CONTACT_WHATSAPP}>
              <IconWhatsapp color={'white'} />
            </IconLabeled>
          </li>
        </ul>
      </section>
    )
  }
}
